/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios;


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


//Moment.js
import moment from 'moment-timezone'
Vue.prototype.moment = moment;


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer);


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css');


// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css';

Vue.prototype.$checkPermission = (permission) => {
    if(permission){
        if(store.getters.permissions.includes(permission)){
            return true
        }
        return false
    }
    return true
};

Vue.config.productionTip = false;

axios.get('/api/v1/ping/').then(function (response) {
    store.dispatch('setLoginStatus', true);
    if(response.data) store.dispatch('setDevelopment');
    loadVue();
}).catch(function () {
    store.dispatch('setLoginStatus', false);
    loadVue();
});

function loadVue(){

    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            store.dispatch('setLoginStatus', false);
            document.body.style.zoom = "100%";
            router.push('/login')
        }
        return Promise.reject(error)
    });

    if (localStorage.getItem("language") !== null) {
        store.commit('SET_LANGUAGE', localStorage.getItem("language"));
    }

    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app');

}
